<template>
    <div>
        <div class="p-grid">
            <Message v-for="(error, key) in errors()" :key="key" severity="error">
                {{ error }}
            </Message>
            <div class="p-col-12">
                <div class="card">
                    <Menubar :model="menuItems"/>
                </div>
            </div>
            <div class="p-col-12">
                <div class="card">
                    <DataTable
                        ref="dt"
                        :value="datatable.data"
                        :lazy="true"
                        :resizableColumns="true"
                        data-key="id"
                        :paginator="true"
                        :rows="10"
                        :loading="datatable.loading"
                        :total-records="datatable.totalRecords"
                        v-model:filters="datatable.filters"
                        editMode="cell"
                        class="editable-cells-table"
                        paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        :rows-per-page-options="[5,10,25]"
                        current-page-report-template="Показані {first} - {last} записів з {totalRecords}"
                        :rowClass="rowClass"
                        @page="onPage($event)"
                        @sort="onSort($event)"
                        @filter="onSort($event)"
                    >
                        <template #header>
                            <div class="table-header">
                                <div style="display: flex; justify-content: space-between;">
                                    <h5 class="p-m-0">
                                        Користувачі
                                    </h5>
                                    <div>
                                        <div class="d-flex justify-content-end" style="gap: 10px;">
                                            <a :href="route('api.users.export')">
                                                <Button icon="pi pi-external-link" label="Скачати в Excel" />
                                            </a>
                                            <a href="javascript:void(0)" @click="copyExportUrl()">
                                                <Button icon="pi pi-copy" />
                                            </a>
                                        </div>
                                        <span class="text_info_secondary">
                                            Завантаження за посиланням доступне для ip:
                                            <a href="javascript:void(0);">{{ ips }}</a>
                                        </span>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div class="form-group">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon">
                                                <i class="pi pi-user"></i>
                                            </span>
                                            <InputText
                                                v-model="datatable.filters.global.value"
                                                v-on:keyup.enter="loadLazyData"
                                                placeholder="Пошук по імені, прізвищу, email"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group table-dropdown">
                                        <Dropdown v-model="datatable.filters.role.value" v-on:change="loadLazyData()" optionLabel="name" optionValue="value" :options="roles" placeholder="Роль" class="w-full md:w-14rem" />
                                    </div>
                                    <div class="form-group" style="display: flex; align-items: center; gap: 10px;">
                                        <Checkbox v-model="datatable.showTrashed" v-on:change="loadLazyData()" :binary="true" />
                                        <label>Відображати видалені</label>
                                    </div>
                                </div>

                                <Button
                                    v-if="selectedUsers.length"
                                    style="margin-top: 20px;"
                                    label="Видалити вибрані"
                                    severity="danger"
                                    @click="deleteMultiple"
                                />
                            </div>
                        </template>
                        <Column headerStyle="width: 3rem">
                            <template #header>
                                <input type="checkbox" :checked="checkedAll" @click="selectAll"/>
                            </template>
                            <template #body="slotProps">
                                <input type="checkbox" :value="slotProps.data.id" v-model="selectedUsers"/>
                            </template>
                        </Column>
                        <Column field="id" header="ID" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.id }}
                            </template>
                        </Column>
                        <Column field="name" header="Ім'я" style="width:20%">
                            <template #editor="{ data, field }">
                                <InputText v-model="data['name']" />
                            </template>
                        </Column>
                        <Column field="last_name" header="Прізвище" style="width:20%">
                            <template #editor="{ data, field }">
                                <InputText v-model="data['last_name']" />
                            </template>
                        </Column>
                        <Column field="email" header="E-mail" :sortable="true">
                            <template #body="slotProps">
                                <p class="text_truncated" v-tooltip.bottom="slotProps.data.email">{{ slotProps.data.email }}</p>
                            </template>
                        </Column>
                        <Column field="company" header="Назва компанії" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.company }}
                            </template>
                        </Column>
                        <Column field="is_activated" header="Активація" :sortable="true">
                            <template #body="slotProps">
                                <span :class="{color_new: !slotProps.data.is_activated}">{{ slotProps.data.is_activated ? 'Активний' : 'Новий' }}</span>
                            </template>
                        </Column>
                        <Column field="role" header="Роль" :sortable="false">
                            <template #body="slotProps">
                                {{ getRoleName(slotProps.data.role) }}
                            </template>
                        </Column>
                        <Column header="Опции" style="width: 150px;">
                            <template #body="slotProps">
                                <Button
                                    icon="pi pi-pencil"
                                    class="p-button-success p-button-sm mr-1"
                                    @click="editModel(slotProps.data)"
                                />
                                <Button
                                    icon="pi pi-eye"
                                    class="p-button-success p-button-sm mr-1"
                                    v-if="datatable.showTrashed"
                                    @click="activate(slotProps.data)"
                                />
                                <Button icon="pi pi-trash" class="p-button-sm p-button-danger"
                                        @click="onDelete(slotProps.data)"
                                />
                            </template>
                        </Column>
                        <template #empty>
                            Немає даних для відображення
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>


        <Dialog
            v-model:visible="modelDialog"
            :style="{ width: '900px' }"
            header="Користувач"
            :modal="true"
            class="p-fluid"
        >
            <TabView>
                <TabPanel header="Основна інформація">
                <div class="field" v-if="model.role === 'client'">
                    <label for="company">Найменування компанії</label>
                    <InputText
                        id="company"
                        v-model.trim="model.company"
                        required="true"
                        autofocus
                        :class="{ 'p-invalid': submitted && !model.company }"
                    />
                    <small class="p-invalid" v-if="submitted && !model.company">Company is required.</small>
                </div>
                <div class="field-group" v-if="model.role === 'client'">
                    <div class="field">
                        <label for="position">Посада</label>
                        <InputText
                            id="position"
                            v-model.trim="model.position"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.position }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.position"
                        >Position is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="code">Код ЄДРПО</label>
                        <InputText
                            id="code"
                            v-model.trim="model.code"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.code }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.code"
                        >Code is required.</small
                        >
                    </div>
                </div>
                <div class="field-group">
                    <div class="field">
                        <label for="name">Ім'я</label>
                        <InputText
                            id="name"
                            v-model.trim="model.name"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.name }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.name"
                        >Name is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="last_name">Прізвище</label>
                        <InputText
                            id="last_name"
                            v-model.trim="model.last_name"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.last_name }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.last_name"
                        >Last name is required.</small
                        >
                    </div>
                </div>
                <div class="field-group">
                    <div class="field">
                        <label for="description">Email</label>
                        <InputText
                            type="email1"
                            id="email"
                            v-model.trim="model.email"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.email }"
                        />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.email"
                        >Email is required.</small
                        >
                    </div>
                    <div class="field" v-if="model.role === 'client'">
                        <label for="phone">Телефон</label>
                        <InputText
                            id="phone"
                            v-model.trim="model.phone"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.phone }"
                        />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.phone"
                        >Phone is required.</small
                        >
                    </div>
                </div>
                <div class="field">
                    <Checkbox v-model="model.is_activated" :binary="true" />
                    Активація
                </div>
                <div class="field">
                    <p>Роль:</p>
                    <RadioButton name="role" value="admin" v-model="model.role" /> Адміністратор <br>
                    <RadioButton name="role" value="service_admin" v-model="model.role" /> Адміністратор сервісів<br>
                    <RadioButton name="role" value="sale" v-model="model.role" /> Менеджер з продажу <br>
                    <RadioButton name="role" value="osp" v-model="model.role" /> ОСП <br>
                    <RadioButton name="role" value="client" v-model="model.role" /> Клієнт <br>
                    <RadioButton name="role" value="pm" v-model="model.role" /> ПМ/АПМ
                </div>
                <div class="field" v-if="model.id">
                    <Checkbox v-model="changePassword" :binary="true" />
                    Изменить пароль
                </div>
                <div class="field" v-if="!model.id || model.id && changePassword">
                    <label for="description">Пароль</label>
                    <InputText
                        type="password"
                        id="password"
                        v-model.trim="model.password"
                        required="true"
                        autofocus
                        :class="{ 'p-invalid': submitted && !model.password }"
                    />
                    <small
                        class="p-invalid"
                        v-if="submitted && !model.password"
                    >Password is required.</small
                    >
                </div>
                </TabPanel>
                <TabPanel header="Аналітика">
                    <table>
                        <tr>
                            <td>Дата реєстрації:</td>
                            <td>{{ moment(model.created_at).format("h:mm:ss DD-MM-YYYY") }}</td>
                        </tr>
                        <tr>
                            <td>Дата останнього входу:</td>
                            <td>{{ moment(model.last_login).format("h:mm:ss DD-MM-YYYY") }}</td>
                        </tr>
                        <tr>
                            <td>Кількість входів:</td>
                            <td>{{ model.login_count }}</td>
                        </tr>
                        <tr>
                            <td>Час проведений в прайс-листі:</td>
                            <td>{{ analytics.total_time }}</td>
                        </tr>
                        <tr>
                            <td>Кількість IP-адрес:</td>
                            <td>{{ analytics.ip_count }}</td>
                        </tr>
                        <tr>
                            <td>Кількість завантажень прайсу:</td>
                            <td>{{ analytics.count_download }}</td>
                        </tr>
                        <tr>
                            <td>Дата останнього завантаження прайсу:</td>
                            <td>{{ analytics.last_download ? moment(analytics.last_download).format("h:mm:ss DD-MM-YYYY") : '' }}</td>
                        </tr>
                    </table>
                </TabPanel>
            </TabView>
            <template #footer>
                <Button
                    label="Cancel"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="hideDialog"
                />
                <Button
                    label="Save"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveModel"
                />
            </template>
        </Dialog>

        <!-- <DeleteDialog
            ref="deleteDialog"
            v-model:visible="deleteDialog"
            :loading="deletingModel"
            @delete="onDelete"
        /> -->
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import {FilterMatchMode} from "primevue/api";
import DatatableService from "../../Services/DatatableService";
import UserService from "../../Services/UserService";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Button from "primevue/button";
import DeleteDialog from "../../Components/DeleteDialog";
import InputText from "primevue/inputtext";
import Dialog from "primevue/dialog";
import Checkbox from 'primevue/checkbox';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
import Message from 'primevue/message';
import RadioButton from 'primevue/radiobutton';
import Dropdown from 'primevue/dropdown';
import swal from 'sweetalert2';
import axios from "axios";
import Label from '../../Jetstream/Label.vue';
import Input from '../../Jetstream/Input.vue';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import moment from "moment";
import Tooltip from 'primevue/tooltip';

export default {
    props: {
        ips: {
            type: String,
            required: false,
        }
    },
    name: "Index",
    directives: {
        Tooltip,
    },
    layout: AppLayout,
    components: {
        Checkbox,
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        InputText,
        Dialog,
        JetValidationErrors,
        Message,
        RadioButton,
        Dropdown,
        swal,
        Input,
        TabView,
        TabPanel,
    },

    data() {
        return {
            moment: moment,
            checkedAll: false,
            changePassword: false,
            multipleSelect: [],
            selectedUsers: [],
            analytics: {},
            datatable: {
                loading: true,
                totalRecords: 0,
                data: null,
                showTrashed: false,
                filters: {
                    'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                    'role': {value: null, matchMode: FilterMatchMode.EQUALS},
                },
                lazyParams: {}
            },
            roles: [
                {
                    name: 'Все',
                    value: null,
                },
                {
                    name: 'Администратор',
                    value: 'admin',
                },
                {
                    name: 'Администратор сервисов',
                    value: 'service_admin',
                },
                {
                    name: 'Менеджер по продажам',
                    value: 'sale',
                },
                {
                    name: 'ОСП',
                    value: 'osp',
                },
                {
                    name: 'Клиент',
                    value: 'client',
                },
                {
                    name: 'ПМ/АПМ',
                    value: 'pm',
                },
            ],
            menuItems: [
                {
                    label: 'Додати користувача',
                    icon: 'pi pi-fw pi-plus',
                    command: () => {
                        this.openNew();
                    },
                },
            ],
            importDialog: false,
            importForm: this.$inertia.form({
                file: null
            }),
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
            model: {},
            modelDialog: false,
        }
    },
    datatableService: null,
    userService: null,
    created() {
        this.datatableService = new DatatableService();
        this.userService = new UserService();
    },
    mounted() {
        this.datatable.loading = true;
        this.datatable.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: 'id',
            sortOrder: -1,
            filters: this.datatable.filters,
            showTrashed: this.datatable.showTrashed,
        };
        this.loadLazyData();
    },
    methods: {
        isRole(name) {
            return this.$page.props.user.role === name;
        },
        selectAll () {
            this.checkedAll = !this.checkedAll

            if (this.checkedAll) {
                for (const item of this.datatable.data) {
                    this.selectedUsers.push(item.id)
                }
            } else {
                this.selectedUsers = []
            }
        },
        rowClass (data) {
            return [{ 'bg-row-danger': this.datatable.showTrashed, 'bkgnd_color_new': !data.is_activated }];
        },
        deleteMultiple () {
            if (!this.selectedUsers.length) {
                return
            }

            new swal({
                title: 'Ви впевнені?',
                text: this.datatable.showTrashed ? 'Користувачі будуть повністю видалені із системи' : 'Користувачі будуть видалені та не матимуть доступу до особистого кабінету',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    return
                }

                let ids = [];

                for (const id of this.selectedUsers) {
                    ids.push(id)
                }

                if (this.datatable.showTrashed) {
                    axios.post('/users/force-delete', {ids: ids})
                        .then(({data: {message}}) => {
                            this.loadLazyData()
                        })
                        .catch((response) => {
                            console.log(response);
                        });
                } else {
                    axios.post('/users/delete-multiple', {ids: ids})
                        .then(({data: {message}}) => {
                            this.loadLazyData()
                        })
                        .catch((response) => {
                            console.log(response);
                        });
                }
            });
        },
        getRoleName(code) {
            const roles = {
                admin: 'Администратор',
                service_admin: 'Администратор сервисов',
                sale: 'Менеджер по продажам',
                osp: 'ОСП',
                client: 'Клиент',
                pm: 'ПМ/АПМ',
            }

            return roles[code]
        },
        errors() {
            return this.$page.props.errors
        },
        hasErrors() {
            return Object.keys(this.errors).length > 0;
        },
        loadLazyData() {
            this.datatable.lazyParams.showTrashed = this.datatable.showTrashed;

            this.datatable.loading = true;
            this.datatableService.getData(this.route('users.datatable'), this.datatable.lazyParams).then(data => {
                this.datatable.data = data.data;
                this.datatable.totalRecords = data.total;
                this.datatable.loading = false;
                this.selectedUsers = []
                this.checkedAll = false
            });
        },
        getUserAnalytics() {
            axios.post(this.route('users.analytics'), {id: this.model.id})
                .then((result) => {
                    this.analytics = result.data;
                    window.scroll(0, 0);
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },
        onPage(event) {
            this.datatable.lazyParams = event;
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
        },
        onSort(event) {
            this.datatable.lazyParams = event;
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
        },

        openNew() {
            this.model = {};
            this.submitted = false;
            this.modelDialog = true;
        },
        hideDialog() {
            this.modelDialog = false;
            this.submitted = false;
        },
        saveModel() {
            this.submitted = true;
            if (this.model) {
                if (this.model.id) {
                    this.$inertia.put(this.route('users.update', this.model.id), this.model, {
                        onSuccess: () => {
                            this.loadLazyData();
                        }
                    })
                }
                // If empty then add new record
                else {
                    this.$inertia.post(this.route('users.store', this.model.id), this.model, {
                        onSuccess: () => {
                            this.loadLazyData();
                        }
                    })
                    // this.userService
                    //     .create(this.model)
                    //     .then((response) => {
                    //         this.model = response.data.data;
                    //         this.datatable.data.unshift(this.model);
                    //         this.$toast.add({
                    //             severity: "success",
                    //             summary: "Successful",
                    //             detail: "User Created",
                    //             life: 3000,
                    //         });
                    //     })
                    //     .catch((error) => {
                    //         this.$toast.add({
                    //             severity: "error",
                    //             summary: "Error",
                    //             detail: "User not created",
                    //             life: 3000,
                    //         });
                    //     });
                }
                this.modelDialog = false;
                this.model = {};
            }
        },
        editModel(model) {
            this.model = { ...model };
            this.getUserAnalytics()
            this.modelDialog = true;
        },
        showDeleteDialog(model) {
            this.selectedModel = model;
            this.deleteDialog = true;
        },
        onDelete(selectedModel) {

            new swal({
                title: 'Ви впевнені?',
                text: this.datatable.showTrashed ? 'Користувач буде повністю вилучений із системи' : 'Користувач буде видалений і не матиме доступу до особистого кабінету',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    return
                }

                if (this.datatable.showTrashed) {
                    axios.post('/users/force-delete', {ids: [selectedModel.id]})
                        .then(({data: {message}}) => {
                            this.loadLazyData()
                        })
                        .catch((response) => {
                            console.log(response);
                        });
                } else {
                    this.$inertia.delete(this.route('users.destroy', selectedModel.id), {
                        onSuccess: () => {
                            this.deletingModel = false;
                            this.deleteDialog = false;
                            this.loadLazyData();
                            this.$refs.deleteDialog.onClose();
                        }
                    })
                }
            });
        },
        activate(selectedModel) {

            new swal({
                title: 'Ви впевнені?',
                text: 'Пользователь будет восстановлен и будет иметь доступ к личному кабинету',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    return
                }

                axios.post('/users/restore', {id: selectedModel.id})
                    .then(({data: {message}}) => {
                        this.loadLazyData()
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            });
        },

        copyExportUrl() {
            navigator.clipboard.writeText(window.location.origin + '/export-users');
        }
    }
}
</script>

<style scoped>
.d-flex {
    display: flex;
    align-items: center;
    gap: 20px;
}
.field-group {
    display: flex;
    gap: 12px;
    width: 100%;
}
.field-group .field {
    width: 100%;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.text_truncated {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 200px;
}
.color_new {
    color: #008000;
    font-weight: 900;
}
.text_info_secondary {
    font-size: 10px;
    font-weight: 400;
    color: black;
}
</style>
